var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.591,
    height: 52.788,
    viewBox: "0 0 37.591 52.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1652",
    "data-name": "Grupo 1652",
    transform: "translate(-663 -620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit-location",
    "data-name": "Icon material-edit-location",
    d: "M23.8,3A16.313,16.313,0,0,0,7.5,19.3c0,12.222,16.3,30.263,16.3,30.263s16.3-18.041,16.3-30.263A16.313,16.313,0,0,0,23.8,3Z",
    transform: "translate(658 619.5)",
    fill: "#002e50",
    stroke: "#002e50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1768",
    "data-name": "Trazado 1768",
    d: "M259.547,203.544c.2-.1.858-.471.893-.489s.065-.034.1-.054a16.029,16.029,0,0,0,2.555-1.806l.007-.006.857-.816a.26.26,0,0,0,.031-.336.226.226,0,0,0-.312-.062l-.836.551a17.93,17.93,0,0,1-2.463,1.187,26.2,26.2,0,0,1-9.7,1.739,24.905,24.905,0,0,1-9.821-1.737,9.137,9.137,0,0,1-2.807-1.7.225.225,0,0,0-.324-.009.261.261,0,0,0-.024.344,11.3,11.3,0,0,0,2.779,2.41c.039.026.655.422,1,.615s1.127.563,1.127.563a17.294,17.294,0,0,0,3.965,1.275c.08.016,1.1.216,1.392.223l1.164.11c.429.022,1.058.057,1.417.057a19.884,19.884,0,0,0,7.914-1.558l.063-.028s.776-.342,1.025-.468",
    transform: "translate(430.357 438.063)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIndicator);
export default __webpack_public_path__ + "static/media/smileIndicator.83e228f14275f73084beacae4926cfe1.svg";
export { ForwardRef as ReactComponent };